/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ILanding } from "../../data/interfaces"
import { ILandingStore, useLandingStore } from "../../data/store"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"

/* Protopia Ecosystem component */
export interface ILandingComponentIdScalarProps extends ICompositeWidgetProps {
   
}
const LandingComponentIdScalar = (props: ILandingComponentIdScalarProps): JSX.Element => { 
     return <>
        <Scalar 
            subtitle={ props.subtitle }
            title={props.title }
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={<LandingComponentIdEnabled {...props} />}  
            desabledForm={<LandingComponentIdDisable {...props} />}  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
            onChange={props.onChange}
        />
    </>
}
export default LandingComponentIdScalar

export const LandingComponentIdEnabled = (props: ILandingComponentIdScalarProps): JSX.Element => {
    const currentLanding: ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)
    const getLandingMemberName = ( name: string | undefined = "" ): (keyof ILanding) => {
        if( Object.keys(currentLanding).includes(name) ) {
            return name as keyof ILanding
        }
        return "categories";
    }
    const [value, setValue] = useState<ID>(  props.value || props.default || "" )

    useEffect(() => { 
        setValue( props.value )
    }, [ props.value, currentLanding[ getLandingMemberName( props.component ) ] ])
    
    const _list: any[] = currentLanding[ getLandingMemberName( props.component ) ] as any[]

    const onChange = ( evt:  React.ChangeEvent<HTMLSelectElement> ) => {
        
        console.log( evt.currentTarget, evt.currentTarget.value )
        
        if( props.onChange ) {
            props.onChange( evt.currentTarget.value as ID, props.field, "")
        }
    }
    return <>
        <select className="dark input form-control" value={ value  || "-1" } onChange={ onChange }>
            <option value={ "" } selected={ "" === value || !value } >
                --
            </option>
        {
            Array.isArray(_list) && !!_list
                ?
                _list.map( ( el: any ) => {
                    return <option key={ el.id } value={ el.id } selected={ el.id === value } >
                        { el.title }
                    </option>
                })
                :
                []
        }
        </select>
    </>
}
export const LandingComponentIdDisable = (props: ILandingComponentIdScalarProps): JSX.Element => {
    return <>{ props.value.toString() }</>
}